import ApiService from "./api.service";

const getAction = (type) => {
	switch (type) {
		case "CLICK":
			return "click";
		case "UZUM":
			return "uzum";
		case "PAYME":
			return "payme";
		case "UZCARD":
			return "xumo";
		case "HUMO":
			return "xumo";
		case 'ONE_QR':
			return 'one_qr/create'
		default:
			return "";
	}
};

const FBoxService = {
	async humoClose(fbIp, cashBoxId) {
		try {
			await ApiService.removeHeader();
			// let response = await ApiService.post(fbIp, data);
			// const token = Buffer.from(`m@y(dutyFr##:m@y(dutyFr##P@$Sw0RD)`, 'utf8').toString('base64')
			var requestData = {
				method: "post",
				url: `http://localhost:8888/xumo_close/${cashBoxId}`,
				data: {
					ipAddress: fbIp,
					depName: localStorage.getItem("dep_name") || "",
					cashboxName: localStorage.getItem("cash_number") || "",
				},
				headers: {
					Authorization: `Basic bUB5KGR1dHlGciMjOm1AeShkdXR5RnIjI1BAJFN3MFJEKQ==`,
				},
			};
			let response = await ApiService.customRequest(requestData);
			await ApiService.setHeader();
			return response;
		} catch (error) {
			await ApiService.setHeader();
			throw error;
		}
	},
	async paymentWithQr(fbIp, data, type) {
		try {
			await ApiService.removeHeader();
			// let response = await ApiService.post(fbIp, data);
			// const token = Buffer.from(`m@y(dutyFr##:m@y(dutyFr##P@$Sw0RD)`, 'utf8').toString('base64')
			var requestData = {
				method: "post",
				url: `http://localhost:8888/payment/${getAction(type)}`,
				data: {
					ipAddress: fbIp,
					data: data,
					depName: localStorage.getItem("dep_name") || "",
					cashboxName: localStorage.getItem("cash_number") || "",
				},
				headers: {
					Authorization: `Basic bUB5KGR1dHlGciMjOm1AeShkdXR5RnIjI1BAJFN3MFJEKQ==`,
				},
			};
			let response = await ApiService.customRequest(requestData);
			await ApiService.setHeader();
			return response;
		} catch (error) {
			await ApiService.setHeader();
			throw error;
		}
	},
	async checkOneQrStatusPay(invoiceId) {
		try {
			await ApiService.removeHeader()
			var requestData = {
				method: 'get',
				url: `http://localhost:8888/payment/one_qr/status?ipAddress=${fiscalIp}&invoice=${invoiceId}`,
				headers: {
					'Authorization': `Basic bUB5KGR1dHlGciMjOm1AeShkdXR5RnIjI1BAJFN3MFJEKQ==`
				}
			};
			let response = await ApiService.customRequest(requestData);
			await ApiService.setHeader()
			return response
		} catch (error) {
			await ApiService.setHeader()
			throw error;
		}
	},
	async orderCreate(fbIp, data, saleId) {
		try {
			await ApiService.removeHeader();
			// let response = await ApiService.post(fbIp, data);
			// const token = Buffer.from(`m@y(dutyFr##:m@y(dutyFr##P@$Sw0RD)`, 'utf8').toString('base64')
			var requestData = {
				method: "post",
				url: `http://localhost:8888/order/create`,
				data: { ipAddress: fbIp, data: data, saleId: saleId },
				headers: {
					Authorization: `Basic bUB5KGR1dHlGciMjOm1AeShkdXR5RnIjI1BAJFN3MFJEKQ==`,
				},
			};
			let response = await ApiService.customRequest(requestData);
			await ApiService.setHeader();
			return response;
		} catch (error) {
			await ApiService.setHeader();
			throw error;
		}
	},
	async orderRefuse(fbIp, data) {
		try {
			await ApiService.removeHeader();
			var requestData = {
				method: "post",
				url: `http://localhost:8888/order/refuse`,
				data: { ipAddress: fbIp, data: data },
				headers: {
					Authorization: `Basic bUB5KGR1dHlGciMjOm1AeShkdXR5RnIjI1BAJFN3MFJEKQ==`,
				},
			};
			let response = await ApiService.customRequest(requestData);
			await ApiService.setHeader();
			return response;
		} catch (error) {
			await ApiService.setHeader();
			throw error;
		}
	},
	async xAndZReportCloseOrPrint({
		ipAddress,
		data,
		closeZReport,
		salesEur,
		totalEur,
		sellerName,
		cashboxName,
		depName,
	}) {
		try {
			await ApiService.removeHeader();
			var requestData = {
				method: "post",
				url: `http://localhost:8888/zreport/close`,
				data: {
					closeZReport: closeZReport,
					ipAddress: ipAddress,
					data: data,
					salesEur: salesEur,
					totalEur: parseFloat(totalEur).toFixed(2),
					name: `Отдел: ${depName} \nКасса: ${cashboxName} \nКассир: ${sellerName}\n`,
				},
				headers: {
					Authorization: `Basic bUB5KGR1dHlGciMjOm1AeShkdXR5RnIjI1BAJFN3MFJEKQ==`,
				},
			};
			let response = await ApiService.customRequest(requestData);
			await ApiService.setHeader();
			return response;
		} catch (error) {
			await ApiService.setHeader();
			throw error;
		}
	},
	async zReportOpen(ipAddress) {
		try {
			await ApiService.removeHeader();
			var requestData = {
				method: "get",
				url: `http://localhost:8888/zreport/open?ipAddress=${ipAddress}`,
				headers: {
					Authorization: `Basic bUB5KGR1dHlGciMjOm1AeShkdXR5RnIjI1BAJFN3MFJEKQ==`,
				},
			};
			let response = await ApiService.customRequest(requestData);
			await ApiService.setHeader();
			return response;
		} catch (error) {
			await ApiService.setHeader();
			throw error;
		}
	},

	async getInfoFiscal() {
		try {
			await ApiService.removeHeader();
			var requestData = {
				method: "get",
				url: `http://localhost:8888/info`,
				headers: {
					Authorization: `Basic bUB5KGR1dHlGciMjOm1AeShkdXR5RnIjI1BAJFN3MFJEKQ==`,
				},
			};
			let response = await ApiService.customRequest(requestData);
			await ApiService.setHeader();
			return response;
		} catch (error) {
			await ApiService.setHeader();
			throw error;
		}
	},

	async setFiscalIpData(data) {
		try {
			await ApiService.removeHeader();
			var requestData = {
				method: "put",
				url: `http://localhost:8888/write?id=${data.id}&name=${data.name}&departmentId=${data.departmentId}&departmentName=${data.departmentName}&ipAddress=${data.ipAddress}&isNew=${data.isNew || false}&isBar=${data.isBar}&isSkyShop=${data.isSkyShop}`,
				headers: {
					Authorization: `Basic bUB5KGR1dHlGciMjOm1AeShkdXR5RnIjI1BAJFN3MFJEKQ==`,
				},
			};
			let response = await ApiService.customRequest(requestData);
			await ApiService.setHeader();
			return response;
		} catch (error) {
			await ApiService.setHeader();
			throw error;
		}
	},
	async getFiscalIpData() {
		try {
			await ApiService.removeHeader();
			var requestData = {
				method: "get",
				url: `http://localhost:8888/read`,
				headers: {
					Authorization: `Basic bUB5KGR1dHlGciMjOm1AeShkdXR5RnIjI1BAJFN3MFJEKQ==`,
				},
			};
			let response = await ApiService.customRequest(requestData);
			await ApiService.setHeader();
			return response;
		} catch (error) {
			await ApiService.setHeader();
			throw error;
		}
	},
};
export default FBoxService;
